import React from "react";
import { useNavigate } from "react-router-dom";
import { HOME } from "../../routes";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-4xl font-bold text-red-600 mb-4">
        404 - Page Not Found
      </h1>
      <p className="text-lg text-gray-700 mb-6">
        The page you're looking for doesn't exist.
      </p>
      <button
        onClick={() => navigate(HOME)}
        className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
      >
        Go to Home
      </button>
    </div>
  );
};

export default NotFound;
